import React, { Fragment } from 'react';
import { object, number, oneOfType, bool } from 'prop-types';
import { ifElse, has, prop, identity, pipe, invoker, split, defaultTo } from 'ramda';
import styled from 'styled-components';

const PriceWrapper = styled.div`
  margin-top: 9px;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  flex-direction: column;
  ${({ discount }) => discount && 'margin: 17px 0px !important;'}
`;

const ReferenceText = styled.span`
  color: #4a4a4a;
  font-size: 14px;
  line-height: 16px;
  ${({ lineThrough }) => lineThrough && 'text-decoration: line-through;'}
  ${({ bold }) => bold && 'font-weight: bold;'}
`;

const NormalText = styled.span`
    margin: 0 1px;
    font-size: 16px;
    color: #4a4a4a;
    line-height: 1.38;
`;

const HighlitedText = styled(NormalText)`
  font-size: 36px;
  line-height: 1;
`;

const getPrice = ifElse(
  has('previous'),
  prop('previous'),
  identity,
);

const splitPrice = pipe(
  getPrice,
  defaultTo(0),
  invoker(1, 'toFixed')(2),
  split('.'),
);

const Price = ({ value = 0.00, posDiscount, visible }) => {
  if (typeof value === 'object') {
    const [currentIntPart, currentFloatPart] = splitPrice(value.current);
    const [previousIntPart, previousFloatPart] = splitPrice(value.previous);
    return (
      <Fragment>
        <PriceWrapper visible={visible}>
          <div>
            <ReferenceText>De R$ </ReferenceText>
            <ReferenceText lineThrough>{previousIntPart},{previousFloatPart}</ReferenceText>
          </div>
        </PriceWrapper>
        <PriceWrapper visible={visible}>
          <div>
            <NormalText>Por </NormalText>
            <NormalText>R$</NormalText>
            <HighlitedText>{currentIntPart}</HighlitedText>
            <NormalText>,{currentFloatPart}</NormalText>
          </div>
        </PriceWrapper>
      </Fragment>
    );
  }

  const [intPart, floatPart] = splitPrice(value);
  return (
    <PriceWrapper discount={posDiscount} visible={visible}>
      <div>
        <NormalText>R$</NormalText>
        <HighlitedText>{intPart}</HighlitedText>
        <NormalText>,{floatPart}</NormalText>
      </div>
    </PriceWrapper>
  );
};
Price.propTypes = {
  value: oneOfType([object, number]).isRequired,
  posDiscount: number,
  visible: bool,
};

Price.defaultProps = {
  visible: true,
  posDiscount: 0,
};

export default Price;
